import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Fetch the client's rows from the database
export const fetchClientRows = async (clientId, userId) => {
  const urlPath = userId ? `${clientId}/${userId}` : `${clientId}`;
  const rows = await axios.get(`/api/client-rows/${urlPath}/`, {
    withCredentials: true,
  });

  return rows.data;
};

// Custom hook to fetch the client's rows
export default function useClientRows(clientId, userId) {
  return useQuery({
    queryKey: ["clientRows", clientId],
    queryFn: () => fetchClientRows(clientId, userId),
    enabled: !!clientId && !!userId,
    refetchInterval: 120000, // refetches every 2 minutes
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
